import { useQuery } from "@tanstack/vue-query";
import { computed, unref, type MaybeRef } from "vue";
import { api } from "./api";
import type { EventsResponse } from "@xs2event/js-lib/api";

export const useEvents = (payload?: MaybeRef) => {
  return useQuery<EventsResponse, never, EventsResponse>({
    queryKey: computed(() => ["events", payload && unref(payload)]),
    queryFn: async () => {
      const response = await api.get("/events", {
        params: { ...unref(payload) },
      });

      return response.data;
    },
    staleTime: 1000 * 60 * 30, //half an hour,
  });
};
